import React, { useState } from "react";
import { api } from "../../../controllers/api";

function Image(props: {
  images: { url: string; public_id: string }[];
  brand_name: string;
}) {
  const [loading, setLoading] = useState(true);
  const handleImageLoad = () => {
    setLoading(false);
  };
  console.log("Image props", props);
  return (
    <div className="_con">
      <img
        loading="lazy"
        style={{ visibility: loading ? "hidden" : "visible" }}
        onLoad={handleImageLoad}
        src={props?.images[0].url}
        alt={props.brand_name}
      />

      {loading && <div className="img-loader"></div>}
    </div>
  );
}

export default Image;
